import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'

export default function ProtectedRoute() {
  const { auth } = useAuth()
  const location = useLocation()

  if (auth.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground text-sm">Loading...</div>
      </div>
    )
  }

  if (!auth.user) {
    // Preserve query string (e.g. ?employee=saba-khan) through the sign-in bounce.
    return <Navigate to={`/?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />
  }

  return <Outlet />
}
